import useServerSentEvents from "sipli-fleet-core/Hooks/useServerSentEvents";
import {
  getCommandHistoryEventUrl,
  type CommandHistoryEvent,
  type CommandStatus,
} from "src/services/commandService";
import { getFromLocal } from "src/util/cache.service";
import { LOCAL_KEYS } from "src/util/util.constant";

interface UseCommandHistoryEventsOptions {
  historyId?: string | number;
  maxReconnectAttempts?: number;
  onMessage: (event: CommandHistoryEvent) => void;
}

interface CommandHistoryEventsResult {
  error: Error | null;
  isLoading: boolean;
  reconnectAttempts: number;
}

const isCommandStatus = (status: unknown): status is CommandStatus =>
  status === 1 || status === 2 || status === 3 || status === 4;

export const useCommandHistoryEvents = ({
  historyId,
  maxReconnectAttempts = 5,
  onMessage,
}: UseCommandHistoryEventsOptions): CommandHistoryEventsResult =>
  useServerSentEvents(
    () => (historyId ? getCommandHistoryEventUrl(historyId) : ""),
    {
      enabled: !!historyId,
      reconnectDelay: 3000,
      maxReconnectAttempts,
      getToken: () => getFromLocal<string>(LOCAL_KEYS.TOKEN, false, true),
      onError: () => undefined,
      onMessage: (payload: unknown) => {
        if (
          !payload ||
          typeof payload !== "object" ||
          !("status" in payload) ||
          !isCommandStatus(payload.status)
        ) {
          return;
        }

        onMessage({ status: payload.status });
      },
    },
  ) as CommandHistoryEventsResult;
